import { ToolPageShell } from '@/shared/seo'
import { PdfPageImagesForm } from '@/features/pdf-page-images'

export function VJpgPage() {
  return (
    <ToolPageShell utilityKey="vJpg">
      <PdfPageImagesForm />
    </ToolPageShell>
  )
}
